import { Facet } from "@linkfluence/models/facet";
import { Timezone } from "@linkfluence/models/timezone";
import { Clause } from "./clause";
import { InsightPage, InsightPageAccess, Row } from "./insight-pages/model";

export type DiscoveryRow = {
  detailsTemplate: string;
  //@TODO : check with backend for the final format
  meta: {
    pageTitle: string;
    pageContext: string;
    query: Clause;
    queryLabel: string;
    period: any;
    periodBackground: any;
    value: {
      value: string;
      display: string;
    };
    field: {
      value:
        | "hashtag"
        | "geo.country"
        | "content-classification"
        | "lang"
        | "tone"
        | "emotion"
        | "keyphrase.normalized-form"
        | "affect.unigram"
        | "affect.ngram";
      display: string;
    };
    increaseMultiplier: number;
    postsPerDay: number;
    postsPerDayBackground: number;
    aicha?: boolean; // Aicha is enabled flag
  };
  page: InsightPage;
};

export type DiscoveryData = {
  dashboardId: number;
  date: string;
  fresh: boolean;
  insightsCount: number;
  projectId: number;
  rows: DiscoveryRow[];
};

export type DiscoveryStatus = Omit<DiscoveryData, "insightsCount" | "rows"> & {
  period: string;
};

/* Feedbacks */
export const FeedbackReasons = [
  "posts_irrelevant",
  "unique_author",
  "repeated_insight",
  "other",
] as const;
export type FeedbackReason = typeof FeedbackReasons[number];

type PositiveFeedback = { feedback: true };
type NegativeFeedback = {
  feedback: false;
  reason: FeedbackReason;
  message?: string;
};
export type DiscoveryFeedback = PositiveFeedback | NegativeFeedback;

// Almost an InsightPage
export type DiscoveryDetails = {
  access: InsightPageAccess;
  author: number;
  description: string;
  dynamicTitle: {
    key: string;
    params: Record<string, string>;
  };
  filters: {
    static: Facet[];
    dynamic: boolean;
  };
  periodSelector: boolean;
  pictureUrl: string;
  projectId: number;
  rows: Row[];
  sharedWith: string[];
  timezone: Timezone;
};

export type SaveOption = {
  id: "save-as-snapshot" | "save-as-new-ip" | "save-in-existing-ip";
  label: string;
  disabled: boolean;
};

export type SaveAction = {
  type: SaveOption["id"];
  payload: {
    discovery: DiscoveryRow["page"];
  };
};
